export const FETCH_HOME_REQUEST = 'FETCH_HOME_REQUEST';
export const FETCH_HOME_FAILURE = 'FETCH_HOME_FAILURE';
export const FETCH_HOME_SUCCESS = 'FETCH_HOME_SUCCESS';
